var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHelmet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "128.000000pt",
    height: "128.000000pt",
    viewBox: "0 0 128.000000 128.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,128.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M515 1269 c-146 -20 -328 -79 -449 -147 -77 -42 -79 -53 -22 -111 l49 -50 -26 -59 c-46 -102 -60 -183 -61 -347 -1 -128 2 -156 18 -188 22 -44 66 -92 105 -111 43 -23 903 -256 942 -256 57 0 137 46 170 98 16 25 29 51 29 57 0 6 -136 62 -302 124 -228 85 -310 120 -333 142 l-30 29 0 170 0 169 29 30 c16 16 41 33 56 36 17 4 126 -19 296 -61 148 -36 273 -67 279 -68 13 -1 7 56 -11 124 -52 184 -199 338 -384 400 -75 26 -241 35 -355 19z m-121 -553 c69 -29 99 -102 71 -174 -45 -110 -205 -110 -250 0 -28 71 1 144 69 174 40 17 69 17 110 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295 634 c-25 -25 -16 -75 18 -94 24 -13 30 -13 55 0 55 31 35 110 -28 110 -16 0 -36 -7 -45 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684 767 c-2 -7 -3 -78 -2 -157 l3 -144 48 -18 47 -18 0 169 c0 185 1 181 -61 181 -16 0 -32 -6 -35 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M850 577 l0 -174 205 -76 c113 -43 210 -77 216 -77 6 0 8 74 7 198 l-3 197 -185 47 c-102 26 -197 50 -212 53 l-28 7 0 -175z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelmet);
export default __webpack_public_path__ + "static/media/helmet.55f865f3f8c694aa267681e02d656a0b.svg";
export { ForwardRef as ReactComponent };